import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Avatar,
  Stack,
  Container,
  IconButton,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CloseIcon from "@mui/icons-material/Close";

import Header from "../components/Header";
import CommonBackdrop from "loader/CommonBackdrop";
import axios from "axios";
import { baseUrl, redirectUrl } from "config";
import { useSnackBar } from "context/snackbarContext";
import { useDispatch, useSelector } from "react-redux";
import { resetOrder, updateOrder } from "../slice/posSlice";
import { resetItems } from "../slice/posItemsSlice";
import filterStatusValue from "utils/filterStatusValue";

const GET_TABLE_DATA = "/getCurrentTableOccupiedList";
const SEND_ORDER = "/HldingStatusChangePos";
const DATA_FOR_PRINT = "/getTermelPrintItems";

function Lists() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackBar();

  const commonState = useSelector((state) => state.common);

  const [isLoading, setIsLoading] = useState(true);
  const [tables, setTables] = useState([]);
  const [error, setError] = useState(null);
  const [isSend, setIsSend] = useState(false);
  const [vr, setVr] = useState(0);
  const [refetch, setRefetch] = useState(false);
  const [isKotPrint, setIsKotPrint] = useState(false);

  const handleApiError = useCallback(
    (err, message = "Failed to fetch data") => {
      console.error("API Error:", err);
      if (err.response) {
        if (err.response.status === 403 || err.response.status === 401) {
          redirectUrl();
        } else {
          showSnackbar(
            "error",
            `${message}: ${err.response.data?.message || err.message}`
          );
        }
      } else if (err.request) {
        showSnackbar("error", `${message}: No response from server.`);
      } else {
        showSnackbar("error", `${message}: An unexpected error occurred.`);
      }
      setError(err);
    },
    [showSnackbar]
  );

  useEffect(() => {
    const getTables = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const res = await axios.get(baseUrl + GET_TABLE_DATA, {
          withCredentials: true,
        });

        if (res.data.success) {
          if (res?.data?.data && res.data.data.length > 0) {
            setTables(res.data.data);
          } else {
            setTables([]);
            showSnackbar("info", "No occupied tables found.");
          }
        } else {
          showSnackbar(
            "error",
            res.data.message || "Failed to retrieve tables."
          );
          setTables([]);
        }
      } catch (err) {
        handleApiError(err, "Failed to fetch tables");
      } finally {
        setIsLoading(false);
      }
    };

    getTables();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refetch]);

  useEffect(() => {
    dispatch(resetItems());
    dispatch(resetOrder());
  }, [location.pathname, dispatch]);

  const navigateToEdit = () => {
    if (vr) {
      navigate(`/pos/form`, { state: { billNo: vr } });
    } else {
      showSnackbar("warning", "Bill No missing");
      setIsLoading(false);
    }
  };

  const handleTableClick = useCallback(
    (tableNumber, billNo = null, HldingStatus) => {
      dispatch(updateOrder({ tableNo: tableNumber }));
      if (HldingStatus === 2) {
        setIsSend(true);
        setVr(billNo);
      } else {
        setIsLoading(true);
        navigate(`/pos/form`);
      }
    },
    [dispatch, navigate]
  );

  const getCardColor = useCallback(
    (itemCount) =>
      itemCount === 2
        ? "linear-gradient(135deg,rgb(145, 107, 221),rgb(108, 69, 185))"
        : "linear-gradient(135deg,rgb(233, 233, 233), #bdbdbd)",
    []
  );

  const getTextColor = useCallback(
    (itemCount) => (itemCount === 2 ? "#fff" : "#333"),
    []
  );

  // handle send Order function
  const handleSendOrder = async () => {
    setIsLoading(true);

    try {
      const res = await axios.post(
        baseUrl + SEND_ORDER,
        { BillNo: vr, HldingStatus: 1 },
        { withCredentials: true }
      );
      if (res.data.success) {
        if (commonState.isInvoice) {
          setIsKotPrint(true);
          setRefetch(!refetch);
        } else {
          setRefetch(!refetch);
        }
        setIsSend(false);
      } else {
        showSnackbar("error", "Error send Order");
      }
    } catch (err) {
      handleApiError(err, "Failed to fetch tables");
    } finally {
      setIsLoading(false);
      // setIsSend(false);
    }
  };

  // to get master data and table data for print
  const handlePrintInvoice = () => {
    axios
      .post(
        baseUrl + DATA_FOR_PRINT,
        {
          BillNo: vr,
          typ: "SB",
          invoicePrint: true,
        },
        { withCredentials: true }
      )
      .then((response) => {
        // const billData = response.data[0][0];
        const allData = response.data;

        navigate("/printer/printerCheck", {
          state: {
            data: allData[0][0],
            tableData: allData[1],
            qrData: "",
            // printType: printrtTyp[0][0].Description,
            printType: filterStatusValue(
              commonState?.printrtTyp?.[0],
              "Typ",
              "WEB_PRINT"
            )[0].Description,
            typ: "SB",

            isInvoiceData: {
              invoiceOnly: commonState.isInvoice,
              isInvoice: commonState.isInvoice,
              isKot: false,
              isALLKot: false,
            },

            kotTableData: [],
            navigateBackThermalDirect: "/pos/section",
            navigateBack: "/pos/section",
          },
        });
        setRefetch(!refetch);
        // navigate(-2);
      })

      .catch((error) => {
        if (
          (error.response && error.response.status === 403) ||
          error.response.status === 401
        ) {
          redirectUrl();
        }
      });
  };

  if (error && !isLoading) {
    return (
      <Container>
        <Header />
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          height="calc(100vh - 64px)"
          textAlign="center"
          p={4}
        >
          <Typography variant="h6" color="error" gutterBottom>
            Oops! Couldn't load tables.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please check your network connection or try again later.
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <>
      <CommonBackdrop open={false} />
      <Header />

      <Dialog
        open={isSend}
        onClose={() => {
          setIsSend(false);
          setIsLoading(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          Confirm your action
          <IconButton
            aria-label="close"
            onClick={() => {
              setIsSend(false);
              setIsLoading(false);
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description" sx={{ mb: 2 }}>
            Please choose what you want to do with this order.
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            disabled={isLoading}
            onClick={() => handleSendOrder()}
            color="primary"
            variant="contained"
          >
            Send Order
          </Button>
          <Button
            disabled={isLoading}
            onClick={() => navigateToEdit()}
            color="secondary"
            variant="contained"
          >
            Edit Order
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={isKotPrint}
        onClose={() => {
          setIsKotPrint(false);
          setIsLoading(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          Print
          <IconButton
            disabled={isLoading}
            aria-label="close"
            onClick={() => {
              setIsKotPrint(false);
              setIsLoading(false);
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description" sx={{ mb: 2 }}>
            Do you want to print invoice?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            disabled={isLoading}
            color="primary"
            variant="contained"
            onClick={() => {
              setIsKotPrint(false);
              setIsLoading(false);
              setRefetch(!refetch);
            }}
          >
            No
          </Button>
          <Button
            disabled={isLoading}
            color="secondary"
            variant="contained"
            onClick={handlePrintInvoice}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Container>
        <Box sx={{ padding: 2 }}>
          <Typography variant="h4" fontWeight={700} mb={2}>
            Tables
          </Typography>

          <Grid container spacing={2}>
            {tables.length > 0
              ? tables.map((table) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={table.Typ}>
                    <Card
                      sx={{
                        borderRadius: 3,
                        background: getCardColor(table.HldingStatus),
                        color: getTextColor(table.HldingStatus),
                        boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
                        transition: "0.3s",
                        "&:hover": {
                          transform: "translateY(-4px)",
                          boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                        },
                      }}
                    >
                      <CardActionArea
                        onClick={() =>
                          handleTableClick(
                            table.Typ,
                            table.BillNo,
                            table.HldingStatus
                          )
                        }
                      >
                        <CardContent>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                              flexWrap: "wrap",
                            }}
                          >
                            <Stack
                              direction={{ xs: "column", sm: "row" }}
                              spacing={1}
                              alignItems="center"
                            >
                              <Avatar
                                sx={{
                                  bgcolor:
                                    table.HldingStatus === 2
                                      ? "#fff"
                                      : "#424242",
                                  color:
                                    table.HldingStatus === 2
                                      ? "rgb(108, 69, 185)"
                                      : "#fff",
                                  width: 44,
                                  height: 44,
                                }}
                              >
                                <TableRestaurantIcon fontSize="small" />
                              </Avatar>
                              <Typography
                                variant="subtitle1"
                                sx={{
                                  color: getTextColor(table.HldingStatus),
                                }}
                                fontWeight={600}
                              >
                                {table.Typ}
                              </Typography>
                            </Stack>

                            <Stack
                              direction="column"
                              spacing={1.5}
                              alignItems="center"
                              justifyContent="flex-end"
                              sx={{ mt: { xs: 2, sm: 0 } }}
                            >
                              <Stack
                                direction="row"
                                spacing={0.5}
                                alignItems="center"
                              >
                                <ShoppingCartIcon
                                  fontSize="small"
                                  sx={{
                                    color: getTextColor(table.HldingStatus),
                                  }}
                                />
                                <Typography
                                  sx={{
                                    color: getTextColor(table.HldingStatus),
                                  }}
                                  variant="body2"
                                >
                                  {table.HldingStatus === 2
                                    ? table.SalesBillCount
                                    : 0}
                                  &nbsp;items
                                </Typography>
                              </Stack>

                              <Stack
                                direction="row"
                                spacing={0.5}
                                alignItems="center"
                              >
                                <CurrencyRupeeIcon
                                  fontSize="small"
                                  sx={{
                                    color: getTextColor(table.HldingStatus),
                                  }}
                                />
                                <Typography
                                  sx={{
                                    color: getTextColor(table.HldingStatus),
                                  }}
                                  variant="body1"
                                >
                                  {table.HldingStatus === 2
                                    ? table.BillNetTotalField.toFixed(
                                        commonState.decimalCount || 0
                                      )
                                    : 0}
                                </Typography>
                              </Stack>
                            </Stack>
                          </Box>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                ))
              : !isLoading && (
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      height="calc(100vh - 200px)"
                      textAlign="center"
                      p={4}
                    >
                      <Typography
                        variant="h6"
                        color="text.secondary"
                        gutterBottom
                      >
                        No tables currently occupied.
                      </Typography>
                      <Typography variant="body2" color="text.disabled">
                        New orders can be started from the form.
                      </Typography>
                    </Box>
                  </Grid>
                )}
          </Grid>
        </Box>
      </Container>
    </>
  );
}

export default Lists;
